import React, { useMemo, useState } from "react";
import styled from "styled-components";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
`;

const Controls = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const Button = styled.button`
  border: 1px solid ${({ theme }) => theme.darkGray};
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.primaryDark};
  border-radius: 4px;
  padding: 0.3rem 0.6rem;
  cursor: pointer;
`;

const Frame = styled.iframe`
  width: 100%;
  min-height: 70vh;
  border: 0;
`;

const Image = styled.img`
  width: 100%;
  max-height: 75vh;
  object-fit: contain;
`;

export default function PhotoGallery(props) {
  const { images = [] } = props;
  const docs = useMemo(
    () => images.map((uri) => ({ uri, fileType: getFileTypeByPath(uri) })),
    [images],
  );
  const [index, setIndex] = useState(0);

  if (!docs.length) return <div>No documents found.</div>;

  const current = docs[index];
  const isPdf = current.fileType === "pdf";
  const isImage = current.fileType === "jpg" || current.fileType === "png";

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(docs.length - 1, i + 1));

  return (
    <div>
      <Header>
        <div>
          Document {index + 1} of {docs.length}
        </div>
        <Controls>
          <Button onClick={prev} disabled={index === 0}>
            Previous
          </Button>
          <Button onClick={next} disabled={index >= docs.length - 1}>
            Next
          </Button>
          <Button onClick={() => window.open(current.uri, "_blank")}>
            Open
          </Button>
        </Controls>
      </Header>

      {isPdf ? (
        <Frame title="Document preview" src={current.uri}></Frame>
      ) : null}
      {isImage ? (
        <Image alt="Document preview" src={current.uri}></Image>
      ) : null}
      {!isPdf && !isImage ? (
        <div>
          Preview is not supported for this file type.{" "}
          <a href={current.uri}>Download file</a>
        </div>
      ) : null}
    </div>
  );
}

function getFileTypeByPath(path) {
  const raw = String(path || "").toLowerCase();
  const decoded = decodeURIComponent(raw);

  if (/\.pdf($|[?#]|%2f|\/)/i.test(decoded)) return "pdf";
  if (/\.jpe?g($|[?#]|%2f|\/)/i.test(decoded)) return "jpg";
  if (/\.png($|[?#]|%2f|\/)/i.test(decoded)) return "png";
  return undefined;
}
